import { mapState } from 'vuex'
import Color from 'color'
export default {
  computed: {
    ...mapState('server', {
      globalPrimaryColor: 'primaryColor',
    }),
    globalStylePrimaryColorBackground () {
      return { backgroundColor: this.globalPrimaryColor, color: 'white' }
    },
    globalStylePrimaryColorBackgroundLight () {
      return { backgroundColor: Color(this.globalPrimaryColor).alpha(0.1), color: 'white' }
    },
    globalStylePrimaryColorText () {
      return { color: this.globalPrimaryColor }
    },
  },
}
